/**
 * 路由保护组件
 */
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { usePricingStore } from '../store/pricingStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const token = useAuthStore((state) => state.token);

  const localStorageToken = localStorage.getItem('token');
  const hasValidToken = token || localStorageToken;

  if (!hasValidToken) {
    console.warn('ProtectedRoute: 未找到有效 token，重定向到登录页');
    return <Navigate to="/login" replace />;
  }

  console.log('ProtectedRoute: 认证检查通过，允许访问');
  return <>{children}</>;
};

/**
 * 需要付费才能访问的路由（需登录 + 需有效权益）
 */
export const PaidRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { token, user } = useAuthStore();
  const { openPricingModal } = usePricingStore();
  const localStorageToken = localStorage.getItem('token');
  const hasValidToken = token || localStorageToken;
  const isAdmin = user?.role === 'admin';
  const hasQuota = user?.words_quota != null && user.words_quota > 0;
  const expiry = user?.subscription_expiry;
  const needsPayment = !hasValidToken ? false : !isAdmin && !hasQuota && (!expiry || new Date(expiry) <= new Date());

  useEffect(() => {
    if (needsPayment) {
      openPricingModal();
    }
  }, [needsPayment, openPricingModal]);

  if (!hasValidToken) {
    return <Navigate to="/login" replace />;
  }

  if (isAdmin) {
    return <>{children}</>;
  }

  if (needsPayment) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-primary/10 flex items-center justify-center">
            <svg className="w-8 h-8 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <h3 className="text-base font-semibold text-foreground mb-1">请先开通 VIP</h3>
          <p className="text-sm text-muted-foreground">开通 VIP 后方可访问此功能</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
